
    <div class="modal-column">
      <form (ngSubmit)="preSubmit()" [formGroup]="form" style="width: 100%;">
        <app-currency-selector formControlName="currency" [ignoreCoins]="['usd']"></app-currency-selector>

        <div class="dw-tabs-menu">
          <button class="dw-tabs-item" [routerLink]="['/', { outlets: { modal: 'deposit' } }]">
            <span class="arrow-icon"><i class="fal fa-arrow-up"></i></span> Deposit
          </button>
          <button class="dw-tabs-item active">
            <span class="arrow-icon"> <i class="fal fa-arrow-down"></i> </span> Withdraw
          </button>
        </div>

        <ng-container *ngIf="!summary">
          <h5>Amount to withdraw</h5>
          <div class="amount-to-withdraw-sidelfex">
            <div class="withdraw-input-wrap">
              <input
                type="number"
                formControlName="amount"
                class="input"
                maxlength="25"
                name="amount-to-withdraw"
                [min]="inputStep"
                [step]="inputStep"
                required
                placeholder="0.0000"
              />
              <div class="btc-amount">{{ currency }}</div>
            </div>
            <div>≈</div>
            <div class="withdraw-amount-conversion">
              <div>{{ amountToUsd | currency: 'USD' }}</div>
              <div>Current Rate: {{ 1 | crypto: currency }} = {{ usdRate | currency: 'USD' }}</div>
            </div>
          </div>

          <div class="deposit-limits">
            Maximum withdrawal amount is
            <span class="deposit-limit-feature">{{ maxAmount | crypto: currency }}</span> in 24 hours. Minimum withdraw
            amount is <span class="deposit-limit-feature">{{ minAmount | crypto: currency }}</span
            >.
          </div>

          <div class="_25-px-spacer"></div>

          <div class="input-label">Your wallet address</div>

          <input
            type="text"
            class="input full"
            maxlength="256"
            formControlName="address"
            name="walletAddress"
            placeholder="Paste your {{ currency }} wallet address"
            required
          />

          <button type="button" class="button" [disabled]="!allowSummary()" (click)="summary = true">
            Make a withdrawal
          </button>

          <ng-container *ngIf="currency === 'DAI'">
            <br /><br />
            <p>
              Or <a href="/" (click)="openSupport($event)">contact support</a> if you want to withdraw USD using wire
              transfer.
            </p>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="summary">
          <h5>Withdrawal summary</h5>
          <div class="withdrawal-sideflex">
            <div>{{ currency }} amount</div>
            <div>
              <strong>{{ form.get('amount').value | crypto: currency }}</strong>
            </div>
          </div>
          <div class="withdrawal-sideflex">
            <div>Processing fee</div>
            <div>
              <strong>{{ feeAmount | crypto: currency }}</strong>
            </div>
          </div>
          <div class="withdrawal-sideflex total">
            <div>Total amount</div>
            <div>
              <strong>{{ form.get('amount').value - feeAmount | crypto: currency }}</strong>
            </div>
          </div>
          <div class="_25-px-spacer"></div>
          <div class="input-label">Your wallet address</div>
          <div class="deposit-address-wrap">
            <div>{{ form.get('address').value }}</div>
          </div>
          <div class="_10-px-spacer"></div>
          <div class="input-label">Confirm password</div>
          <input
            type="password"
            class="input full"
            formControlName="password"
            maxlength="256"
            name="password"
            data-name="Enter your password"
            placeholder="Enter your password"
            id="Enter-your-password"
            required=""
          />
          <div class="withdrawal-sidefelx-buttons">
            <button type="button" class="button button-transparent" (click)="summary = false">Go back</button>
            <div class="_20-px-spacer"></div>
            <button type="submit" class="button" [disabled]="form.invalid || loading">Confirm withdrawal</button>
          </div>
        </ng-container>
      </form>
    </div>
    <a [routerLink]="['/', { outlets: { modal: null } }]" class="icon close-popup" data-id="withdraw-close-href">
      <i class="fal fa-times"></i>
    </a>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/withdraw-modal-2.component.ts.WithdrawModal2Component.html